export const BASE_URL_V1 = import.meta.env.VITE_APP_API_URL_V1;
export const BASE_URL_V2 = import.meta.env.VITE_APP_API_URL_V2;
export const BASE_URL_AI = import.meta.env.VITE_APP_API_URL_AI;
export const BASE_URL_STRAPI = import.meta.env.VITE_APP_API_URL_STRAPI;
export const BASE_URL_STRAPI_TOKEN = import.meta.env.VITE_APP_API_URL_STRAPI_TOKEN;
export const SOCKET_URL = import.meta.env.VITE_APP_SOCKET_URL;
export const MEET_URL = import.meta.env.VITE_APP_MEET_URL;
export const WEBSITE_URL = import.meta.env.VITE_APP_WEBSITE_URL;
export const FIREBASE_API_KEY = import.meta.env.VITE_APP_FIREBASE_API_KEY;
export const FIREBASE_AUTH_DOMAIN = import.meta.env.VITE_APP_FIREBASE_AUTH_DOMAIN;
export const FIREBASE_PROJECT_ID = import.meta.env.VITE_APP_FIREBASE_PROJECT_ID;
export const FIREBASE_STORAGE_BUCKET = import.meta.env.VITE_APP_FIREBASE_STORAGE_BUCKET;
export const FIREBASE_MESSAGING_SENDER_ID = import.meta.env.VITE_APP_FIREBASE_MESSAGING_SENDER_ID;
export const FIREBASE_APP_ID = import.meta.env.VITE_APP_FIREBASE_APP_ID;
export const FIREBASE_MEASUREMENT_ID = import.meta.env.VITE_APP_FIREBASE_MEASUREMENT_ID;
export const FIREBASE_VAPID_KEY = import.meta.env.VITE_APP_FIREBASE_VAPID_KEY;
export const REVENUECAT_APP_PUBLIC_API_KEY = import.meta.env.VITE_APP_REVENUECAT_APP_PUBLIC_API_KEY;
export const isProduction = import.meta.env.MODE === "production";
export const MIXPANEL_TOKEN = isProduction ? import.meta.env.VITE_APP_MIXPANEL_TOKEN : undefined;export const MODE = import.meta.env.MODE;